/**
 * Returns to sign in when the token is no longer accepted, rather than surfacing a
 * raw request error on whichever screen made the call. Shared by every axios
 * instance in the app.
 */
let redirecting = false;

export const installExpiryHandler = (instance: any): void => {
  instance.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      const status = error?.response?.status;
      const isLoginCall = String(error?.config?.url || '').includes('/login');
      // A 401 on the sign-in screen means bad credentials, not an expired session.
      if ((status === 401 || status === 403) && !isLoginCall && !redirecting) {
        redirecting = true;
        ['authToken', 'refreshToken', 'user'].forEach((key) => localStorage.removeItem(key));
        sessionStorage.clear();
        window.location.replace('/');
      }
      return Promise.reject(error);
    }
  );
};
